import { TempSavedValue, Applicant, Agency, AppointmentsForRestore } from '../types';

export const isTempSavedValue = (value: unknown): value is TempSavedValue => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const tempValue = value as TempSavedValue;
  return (
    typeof tempValue['書類名'] === 'string' &&
    tempValue['書類名'] === '包括委任状提出書' &&
    typeof tempValue['提出日'] === 'string' &&
    typeof tempValue['委任日'] === 'string' &&
    isApplicant(tempValue['提出者']) &&
    Array.isArray(tempValue['代理人']) &&
    tempValue['代理人'].every(isAgency) &&
    Array.isArray(tempValue['委任事項']) &&
    tempValue['委任事項'].every(isAppointmentGroup) &&
    Array.isArray(tempValue['その他の委任事項']) &&
    tempValue['その他の委任事項'].every(
      (appointment: unknown) => typeof appointment === 'string'
    ) &&
    Array.isArray(tempValue['提出物件']) &&
    tempValue['提出物件'].every(
      (item: unknown) => typeof item === 'string'
    )
  );
};

const isApplicant = (value: unknown): value is Applicant => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const applicant = value as Applicant;
  return (
    typeof applicant['識別番号'] === 'string' &&
    typeof applicant['郵便番号'] === 'string' &&
    typeof applicant['住所又は居所'] === 'string' &&
    typeof applicant['氏名又は名称'] === 'string' &&
    typeof applicant['代表者'] === 'string'
  );
};

const isAgency = (value: unknown): value is Agency => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const agency = value as Agency;
  return (
    typeof agency['手続実行者フラグ'] === 'boolean' &&
    typeof agency['識別番号'] === 'string' &&
    typeof agency['住所又は居所'] === 'string' &&
    typeof agency['氏名又は名称'] === 'string' &&
    typeof agency['代表者'] === 'string'
  );
};

const isAppointmentGroup = (value: unknown): value is AppointmentsForRestore => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  const group = value as AppointmentsForRestore;
  return (
    typeof group['委任事項（メイン）ID'] === 'string' &&
    Array.isArray(group['委任事項（サブ）ID']) &&
    group['委任事項（サブ）ID'].every(
      (id: unknown) => typeof id === 'string'
    ) &&
    Array.isArray(group['法域']) &&
    group['法域'].every(
      (jurisdiction: unknown) => typeof jurisdiction === 'string'
    )
  );
};
